export default __webpack_public_path__ + "static/media/exploration_vs_exploitation.31b24ba6.png";